document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-copy-link').forEach(btn => {
        btn.addEventListener('click', () => {
            const url = btn.dataset.url || window.location.href;

            navigator.clipboard.writeText(url).then(() => {
                btn.classList.add('story-detail__socmed-box--copied');
                setTimeout(() => btn.classList.remove('story-detail__socmed-box--copied'), 2000);
            });
        });
    });
});
